class InspireMeIndexList {
    
    constructor() {
        this.ajax = "";
        this.types = '';
        
        $('.type').on('click', this.onClick.bind(this));

        this.loadList();
    }

    loadList() {		
        $('.loadOverlay').stop().fadeIn('fast');
    
        var data = [];
        
        $('.filterOn').each(function(index, element){
            var ctId = $(element).attr('data-id');
            data.push(ctId);
        });
        
        this.ajax = $.ajax({
            method:'POST',
            cache:false,
            url:'/inspireMe/indexList',
            data: {
                data:JSON.stringify(data),
            }
        }).done(function(html) {
            $('#indexListContainer').html(html);
            $('.loadOverlay').stop().fadeOut('fast');
        });
    }

    onClick(e) {
        $(e.target).toggleClass('filterOn');
        
        this.loadList();
    }
}

new InspireMeIndexList();